import { DesignSystem } from "../design-system.js";
import { MultiViewGroup } from "./multi-view-group.js";
import { styles } from "./multi-view-group.styles.js";
import { template } from "./multi-view-group.template.js";
/**
 *
 * @public
 * @remarks
 * HTML Element: <fluent-multi-view-group>
 */
export const definition = MultiViewGroup.compose({
    name: `${DesignSystem.prefix}-multi-view-group`,
    template,
    styles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=multi-view-group.definition.js.map